module.exports = __webpack_public_path__ + "static/img/Eero_Järnefelt.81e3ef1.jpg";